import * as React from 'react';
import { ActionLink, Body2, UIHeading5, Image } from '@cian/ui-kit';

import stars from './../../../../assets/Stars.svg';
import * as styles from './styles.css';

export interface IFooterBlockProps {
  title: string;
  subtitle: string;
  actionText: string;
}

export const FooterBlock = ({ title, subtitle, actionText }: IFooterBlockProps): React.JSX.Element => {
  return (
    <div className={styles['footer-container']}>
      <div className={styles['icon-wrapper']}>
        <Image height={24} src={stars} width={24} />
      </div>
      <div className={styles['footer-text-wrapper']}>
        <UIHeading5 color="text-secondary-default">{title}</UIHeading5>
        <Body2 color="text-secondary-default">
          {subtitle}{' '}
          <ActionLink color="current_color" inline fontSize="S" textDecoration="underline">
            {actionText}
          </ActionLink>
        </Body2>
      </div>
    </div>
  );
};
